import React, {useState, useEffect, useRef} from 'react';
import Button from 'react-bootstrap/Button';
import {showToast} from '../../common/app_common.js';
import {BadgeChange, useBlockerWithModal} from '../../common/component_common.js';
import {getApiConfigTag, postApiConfigTag} from '../../common/fetch_api/configuration';
import {DecideWindow} from '../../common/modal_common.js';
import {BsTrash, BsPlusSquare,} from 'react-icons/bs';
import { use } from 'react';

export const View = ({existUpdate, setExistUpdate}) => {

    const [update, setUpdate] = useState(false);
    const [inputTag, setInputTag] = useState('');
    const [transmitList, setTransmitList] = useState(null);
    const transmitData = useRef([]);
    const transmitOrg = useRef([]);
    
    const [modalVisible, setModalVisible] = useState(false);
    const [modalCallback, setModalCallback] = useState(null);

    const showModalDecideForRoute = ({ onConfirm }) => {
        setModalVisible(true);
        setModalCallback(() => onConfirm);
    };
    const closeModalDecideForRoute = () => {
        setModalVisible(false);
    };

    useBlockerWithModal(existUpdate, showModalDecideForRoute);

    // DecideWindow에서 OK 클릭 시
    const handleModalOk = (is) => {
        if( is )
        {
            setModalVisible(false);
            if (modalCallback) modalCallback();
        }
    };

    const SetDecideBodyMoveout = () => {
        return (
            <div className='text-center'>
                <p>There are unsaved changes. Are you sure you want to leave this page?</p>
            </div>
    )};
    
    function makeTransmit(tranmit)
    {
        transmitData.current = tranmit;
        const isSame = transmitData.current.every((item, index) => item === transmitOrg.current[index]);
        setExistUpdate(!isSame);
        
        if(tranmit != null) {
            setTransmitList(tranmit.map((tm, index) =>
                <div key={index} className="station-list" onClick={() => {setInputTag(tm)}}>{tm}</div>
            ));
        }
        else
        {
            setTransmitList(null);
        }
    }

    const onClickAddTansmit = () => {
        const value = inputTag;
        let tranmitArr = transmitData.current;
        
        for(const transmit of tranmitArr)
        {
            if( transmit === value )
            {
                return;
            }
        }

        if( value.length < 1 )
        {
            return;
        }

        tranmitArr.push(value);
        makeTransmit(tranmitArr);
        setInputTag('');
    }

    const onClickRemoveTansmit = () => {
        const value = inputTag;
        let tranmitArr = transmitData.current.filter((x) => {return x !== value});
        makeTransmit(tranmitArr);
        setInputTag('');
    }
    
    const onClickSave = () => {
        Promise.resolve ( postApiConfigTag(transmitData.current) )
        .then( done => {
            runUpdate();
        });
    }

    const runUpdate = () => {
        setUpdate(!update);
    };

    useEffect(() => {
        Promise.resolve( getApiConfigTag() )
        .then( tagList => {
            transmitOrg.current = [...tagList];
            makeTransmit(tagList)
        })
    }, [update]);

    return (
        
        <div className="tab-pane show active">
            <div className="section control-tag-area">
                <div className="taglist-area">
                    <div className="section-title">Tag List</div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-3 label-box">TagName</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 ps-1">
                            <input className="form-control input-box" type="text" value={inputTag} onChange={(e) => {setInputTag(e.target.value)}}/>
                        </div>
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 d-flex">
                            <Button variant='primary' className="btn btn-icon ms-2" onClick={onClickAddTansmit}><BsPlusSquare/></Button>
                            <Button variant='danger' className="btn btn-icon ms-2" onClick={onClickRemoveTansmit}><BsTrash/></Button>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-3 label-box">TagList</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 ps-1">
                            <div className="list-box transmit-station">
                                {transmitList}
                            </div>
                        </div>
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 d-flex"></div>
                    </div>
                </div>
                <div className="d-flex my-2">
                    <Button variant="primary" className="btn btn-sm btn-badge-change" onClick={onClickSave}>Save<BadgeChange show={existUpdate}/></Button>
                    <span className={`ms-3 mt-1 text-warning ${existUpdate?"":"d-none"}`}>There are unsaved changes. Please click the Save button to apply your changes.</span>
                </div>
            </div>
            {modalVisible&&<DecideWindow result={handleModalOk} show={modalVisible} handleClose={closeModalDecideForRoute} body={<SetDecideBodyMoveout />} okButtonTxt={'OK'}/>}
        </div>
    )
}